import Immutable from 'immutable';
const baseUrl = process.env.REACT_APP_BACKEND_URL;
export default {
  home: baseUrl + '/api/home?api=3',
  profile: baseUrl + '/api/profil/get?api=3',
  legal: baseUrl + '/api/page/get/legal',
  confidentiality: baseUrl + '/api/page/get/confidentiality',
  ping: baseUrl + '/api/ping',
  login: baseUrl + '/api/auth/login',
  logout: baseUrl + '/api/auth/logout',
  registration: baseUrl + '/api/registration',
  faq: baseUrl + '/api/faq',
  replays: baseUrl + '/api/replay',
  cms: baseUrl + '/api/cms',
  account: baseUrl + '/api/account',
  message: baseUrl + '/api/message',
  orchestrator: baseUrl + "/api/orchestrator",
  quiz: baseUrl + "/api/orchestrator/quiz",
  feedback: baseUrl + "/api/feedback",
  utm: baseUrl + '/api/utm',
  news: baseUrl + '/api/news',
  newsthumbpreview: baseUrl + '/cache/news/{newsId}',
  speedtest: baseUrl + '/api/speedtest',
  stWorker: baseUrl + '/api/st',
  events: baseUrl + '/api/events',
  theme: baseUrl + '/api/theme',
  availableevents: baseUrl + '/api/availableevents',
  myevents: baseUrl + '/api/myevents',
  mypastevents: baseUrl + '/api/mypastevents',
  eventthumbpreview: baseUrl + '/cache/events/{eventId}',
  themethumbpreview: baseUrl + '/cache/themes/{eventId}',
  eventSendInvite: baseUrl + '/api/events/invite',
  eventSubscribe: baseUrl + '/api/events/subscribe',
  eventUnsubscribe: baseUrl + '/api/events/unsubscribe',
  contact: baseUrl + '/api/contact',
  rpwd: baseUrl + '/api/auth/rpwd',
  cpwd: baseUrl + '/api/auth/cpwd',
  fb: '',
  ld: '',
  getJobs: (set) => {
    if (set === 1)
    return [
      // { label: 'Médecin', value: 'md' },
      // { label: 'Pharmacien', value: 'ph' },
      // { label: 'Infirmier', value: 'in' },
      // { label: 'Interne', value: 'int' },
      // { label: 'Interne sans RPPS', value: 'x5' },
      // // { label: 'Etudiant en pharmacie', value: 'x6' },
      // { label: 'Préparateur', value: 'x7' },
    ];
    else
    return [
      // { label: 'Médecin', value: 'x2' },
      // { label: 'Pharmacien', value: 'x4' },
      // { label: 'Infirmier', value: 'x3' },
      // { label: 'Biocodex', value: 'lb' },
    ];
  },
  getJobsCategories: () => {
    return {
      // md: 'isMd',
      // ph: 'isPh',
      // in: 'isIn',
      // int: 'isInt',
      // lb: 'isLb',
      // x1: 'isX1',
      // x2: 'isX2',
      // x3: 'isX3',
      // x4: 'isX4',
      // x5: 'isX5',
      // x6: 'isX6',
      // x7: 'isX7',
    };
  },

  getMenu: ($$user, options) => {
    let userRole;
    if ($$user === undefined) userRole = 'visitor';
    else userRole = $$user.get('role');
    let menu = [];
    // menu.push({ icon: 'home', title: 'Accueil', url: '/' });
    // menu.push({ icon: 'help', title: 'Aide', url: '/help' });
    // menu.push({ icon: 'contact', title: 'Contact', url: '/contact' });
    return options !== undefined && options.asImmutable === true ? Immutable.fromJS(menu) : menu;
  },
  getFooterMenu: ($$user, options) => {
    let userRole;
    if ($$user === undefined) userRole = 'visitor';
    else userRole = $$user.get('role');
    let menu = [];
    menu.push({ icon: 'accueil', title: 'Accueil', url: '/' });
    menu.push({ icon: 'contact', title: 'Contact', url: '/contact' });
    menu.push({ icon: 'privacy', title: 'Données Personnelles', url: '/confidentiality' });
    // menu.push({ icon: 'legal', title: 'Condition Générales', url: '/legal' });

    return options !== undefined && options.asImmutable === true ? Immutable.fromJS(menu) : menu;
  },
  getProfileMenu: ($$user, options) => {
    let userRole;
    let userSubRole;
    if ($$user === undefined) userRole = 'visitor';
    else {
      userRole = $$user.get('role');
      userSubRole = $$user.get('subRole');
    }
    let menu = [];
    // if (userRole === 'member')
    // menu.push({ title: 'Mes événements', url: '/my_events'})
    if (userRole === 'member' || userRole === 'speaker' || userRole === 'staff' || userRole === 'admin')
    menu.push({ title: 'Mon compte', url: '/account' });

    if (userSubRole === 'buadm') {
      menu.push({
        icon: 'account',
        title: 'Professionnels',
        url: '/staff/account/list',
      });
    }
    // if (userSubRole === 'mod' || userSubRole === 'buadm' || userRole === 'speaker') {
    //   menu.push({
    //     icon: 'event',
    //     title: 'Emissions',
    //     url: '/staff/event/list',
    //   });
    //   menu.push({
    //     icon: 'message',
    //     title: 'Modération',
    //     url: "/staff/orchestrator/list",
    //   });
    // }
    // if (userSubRole === 'buadm') {
    //   menu.push({
    //     icon: 'export',
    //     title: 'Exports',
    //     url: '/api/_exports',
    //     target: '_blank',
    //   });
    // }
    if (userRole === 'admin') {
      // menu.push({ icon: 'admin', title: 'Admin', url: '/admin'})
      // menu.push({
      //   icon: 'account',
      //   title: 'Professionnels',
      //   url: '/staff/account/list',
      // });
      // menu.push({
      //   icon: 'theme',
      //   title: 'Thèmes',
      //   url: '/staff/theme/list',
      // });
      // menu.push({
      //   icon: 'event',
      //   title: 'Emissions',
      //   url: '/staff/event/list',
      // });
      menu.push({ icon: 'cms', title: 'CMS', url: '/staff/cms/list' });
      // menu.push({ icon: "news", title: "News", url: "/staff/news/list" });
      // menu.push({
      //   icon: 'utm',
      //   title: 'UTMs',
      //   url: '/staff/utm/list',
      // });

      // menu.push({ icon: 'faq', title: 'FAQ', url: '/staff/faq/list' });
      // menu.push({
      //   icon: 'message',
      //   title: 'Modération',
      //   url: "/staff/orchestrator/list",
      // });
      menu.push({
        icon: 'email',
        title: 'Emails',
        url: '/api/_cron/mail',
        target: '_blank',
      });
      menu.push({
        icon: 'logs',
        title: 'Logs',
        url: '/api/_logs',
        target: '_blank',
      });
      // menu.push({
      //   icon: 'export',
      //   title: 'Exports',
      //   url: '/api/_exports',
      //   target: '_blank',
      // });
    }

    menu.push({ title: 'Se déconnecter', url: '/logout' });
    return options !== undefined && options.asImmutable === true ? Immutable.fromJS(menu) : menu;
  },
};



// WEBPACK FOOTER //
// ./src/config/api.jsx